export default __webpack_public_path__ + "static/media/inCorrect.0fe35952.svg";